const preOrderNote = document.getElementById("preorder-text");
window.globalAllSizesAreMto = false;
window.globalAllSizesArePreorder = false;
window.globalAllSizesAreMtoAndPreorder = false;
window.globalAllSizesAreWaitlist = false;
const standardColorRadios = document.querySelector(".standard-color-radios");
const variantSelectOptions = document.querySelectorAll(
  ".variant-select option",
);
const variantSelectOptionsArray = [...variantSelectOptions];
const handlesWithMtoOrPreorder = [];
variantSelectOptionsArray.forEach((option) => {
  if (option.dataset.madetoorder || option.dataset.preorder) {
    if (!handlesWithMtoOrPreorder.includes(option.dataset.handle)) {
      handlesWithMtoOrPreorder.push(option.dataset.handle);
    }
  }
});

const checkPersonalizationAvailability = () => {
  const personalizationData = document.getElementById(
    "personalization-data-container",
  );
  if (personalizationData) {
    const { enablePersonalization } = personalizationData.dataset;
    return enablePersonalization === "true" || enablePersonalization === true;
  }
  return false;
};

const isPersonalizationEnabled = checkPersonalizationAvailability();

const showElements = (...elements) => {
  elements.forEach((el) => {
    el?.classList.remove("none", "hidden");
  });
};

const hideElements = (...elements) => {
  elements.forEach((el) => {
    el?.classList.add("none", "hidden");
  });
};

// DESKTOP PRODUCT IMAGE SWAP

const swapDesktopImage = (e) => {
  const { full } = e.dataset;
  const toSwap = document.getElementById("product-main");
  const videoContainer = document.getElementById("product-video-container");
  const stylingVideoContainer = document.getElementById(
    "styling-video-container",
  );
  const mainImageContainer = document.getElementById(
    "product-main-image-container",
  );
  if (videoContainer) {
    videoContainer.classList.add("none");
  }

  if (stylingVideoContainer) {
    stylingVideoContainer.classList.add("none");
  }

  mainImageContainer.classList.remove("none");
  if (toSwap && full) {
    toSwap.src = full;
  }
  const pictureContainer = document.getElementById(
    "product-main-image-picture",
  );
  pictureContainer.querySelectorAll("source").forEach((s) => {
    s.remove();
  });
};

/**
 * Sets the main image of the PDP to the first image within the product carousel gallery.
 */
const setMainImageToFirstInGallery = () => {
  const firstImageInGallery = document.querySelector(
    ".product-thumb-container.pdp-thumb img",
  );
  const mainImage = document.querySelector("#product-main-image-picture");
  mainImage.innerHTML = `<img width="1366" height="2048" id="product-main" loading="eager" class="dt-block" src="${firstImageInGallery.src}" />`;
};

function setSelectedSizeImage() {
  const selectedSize = document.querySelector("input.size-radio:checked");
  if (selectedSize) {
    const firstImage = document.querySelector(
      ".product-thumb-container.pdp-thumb img",
    );
    const mainImage = document.querySelector("#product-main-image-picture");
    const desktopCarousel = document.querySelector(".product-image-container");
    const productGallery = document.querySelector("#product-gallery");
    const sizeImage = [...document.querySelectorAll(".pdp-thumb")].find(
      (image) =>
        image.dataset.sizes &&
        image.dataset.sizes.includes(selectedSize.value.toUpperCase()),
    );
    if (sizeImage) {
      mainImage.innerHTML = `<img width="1366" height="2048" id="product-main" loading="eager" class="dt-block" src="${
        sizeImage.querySelector("img").src
      }" />`;
      desktopCarousel.scrollTo({
        top: sizeImage.offsetTop - desktopCarousel.offsetTop,
        left: 0,
        behavior: "smooth",
      });
      productGallery.scrollTo({
        top: 0,
        left: sizeImage.offsetLeft - productGallery.offsetTop,
        behavior: "smooth",
      });
    } else if (!mainImage.querySelector("source")) {
      mainImage.innerHTML = `<img width="1366" height="2048" id="product-main" loading="eager" class="dt-block" src="${firstImage.src}" />`;
      desktopCarousel.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      productGallery.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }
}

const showVideo = (e) => {
  const videoContainer = document.getElementById(
    e.target.closest(".product-video-thumb").dataset.video,
  );
  const galleryVideos = document.querySelectorAll(".product-video-container");
  const stylingVideos = document.querySelectorAll(".styling-video-container");
  const mainImageContainer = document.getElementById(
    "product-main-image-container",
  );
  mainImageContainer.classList.add("none");
  galleryVideos.forEach((video) => {
    video.classList.add("none");
  });
  stylingVideos.forEach((video) => {
    video.classList.add("none");
  });
  videoContainer.classList.remove("none");
};

const loadItemsInGrid = (products, amountToLoad) => {
  if (products) {
    for (let i = amountToLoad; i < products.length; i++) {
      hideElements(products[i]);
    }
  }
};

const getUpsells = (tags) => {
  let tagString = ``;
  const upsellTags = tags.filter((word) => !word.includes("Group"));
  upsellTags.forEach((tag, index) => {
    if (index < 3) {
      tagString += `tag:"${tag.replace("Upsell", "Upsell Group").trim()}"`;
      if (index + 1 !== tags.length) {
        tagString += `+OR+`;
      }
    }
  });

  const host = window.location.hostname;

  fetch(`https://${host}/search?view=dictionary&type=product&q=${tagString}`, {
    method: "GET",
  })
    .then((res) => res.text())
    .then((response) => {
      let data = response;
      data = data.split("let products = ");
      data = data[1].split("</script>");
      let upsells = JSON.parse(data[0]);
      let picked = [];
      let first = null;

      upsells = shuffle(upsells);
      upsellTags.forEach((tag, index) => {
        if (index < 3) {
          const searchTag = tag.replace("Upsell", "Upsell Group").trim();
          const items = upsells.filter((item) => item.tags.includes(searchTag));
          let ind = 0;
          if (searchTag === "Upsell Group Underthings") {
            ind = 2;
          }
          items.forEach((item) => {
            if (item.title.includes("Alby")) {
              first = item;
            }
            if (
              ind < 4 &&
              item.available === "true" &&
              !picked.includes(item)
            ) {
              if (item.title.includes("Alby")) {
                // DO NOTHING
              } else {
                ind += 1;
                picked.push(item);
              }
            }
          });
        }
      });

      picked = shuffle(picked);

      if (first !== null) {
        picked.splice(0, 0, first);
      }

      let upsellContainer = ``;
      picked.forEach((upsell) => {
        const name = upsell.title.split("-");
        let mainName = name[0];
        let fabric = ``;
        if (upsell.type !== "Swatch") {
          window.allFabrics.forEach((f) => {
            if (upsell.tags.includes(f)) {
              fabric = f;
            }
            if (fabric === "Satin") {
              fabric = "Shiny Satin";
            }
          });
        }
        if (upsell.type === "Bridesmaid Dress") {
          mainName = name[0].replace(fabric, "");
        }
        const title = `<div>${mainName}</div>`;
        let subtitle = ``;
        if (name.length > 1) {
          subtitle = `<div class="regular">${fabric} ${name[1].replace(
            " in ",
            " ",
          )}</div>`;
        }
        upsellContainer += `<div class="pointer carousel-item flex snap-start"><a class="no-underline" href="${upsell.url}">
        <div>
          <picture>
            <source media="(max-width:480px)" srcset="${upsell.images[0].src.replace(
              "1600x1600",
              "480x480",
            )}">
            <source media="(min-width:481px) and (max-width:768px)" srcset="${upsell.images[0].src.replace(
              "1600x1600",
              "768x768",
            )}">
            <source media="(min-width:769px)" srcset="${upsell.images[0].src.replace(
              "1600x1600",
              "900x900",
            )}">
            <img alt="${mainName}" width="${upsell.images[0].width}" height="${
              upsell.images[0].height
            }" loading="lazy" class="upsell-carousel-image" src="${
              upsell.images[0].src
            }">
          </picture>
          <div class="font-semibold text-center my-4">${
            upsell.compare_at_price &&
            Number(upsell.price.slice(1)) >
              Number(upsell.compare_at_price.slice(1))
              ? `<span class="text-brand-darkerMocha line-through decoration-2"><span class="text-brand-deepMocha-75">${upsell.price}</span></span><span class="text-brand-darkerMocha ml-2.5">${upsell.compare_at_price}</span>`
              : upsell.price
          }</div>
        </div>
        </a>
      </div>`;
      });
      document.querySelectorAll(".upsell-carousel").forEach((carousel) => {
        if (upsellContainer) {
          carousel.innerHTML = upsellContainer;
          if (document.querySelectorAll(".complete-the-look")) {
            Array.from(document.querySelectorAll(".complete-the-look")).forEach(
              (item) => {
                item.classList.remove("none");
              },
            );
          }
        }
      });
      document.querySelectorAll(".upsell-atc").forEach((button) => {
        button.addEventListener("click", upsellAtc);
      });

      const completeTheLookMobileItems = document.querySelectorAll(
        ".complete-the-look-mobile .horizontal-carousel .upsell-carousel .carousel-item",
      );
      loadItemsInGrid(completeTheLookMobileItems, 4);
    })
    .catch((err) => {});
};

/**
 * Resets the product gallery images on PDP when the status changes from an unavailable or none state
 * to an available, preorder, made to order, or waitlist state.
 *
 * @param {*} status - The availability status of the current product.
 * @returns {void}
 */
const resetProductGalleryImages = (status) => {
  const unavailableImage = document.querySelector(".unavailable-image");

  if (!unavailableImage || status === "unavailable" || status === "none")
    return;

  // Remove the unavailable image and show all the images in the gallery.
  unavailableImage.remove();
  const productGallery = document.getElementById("product-gallery");
  productGallery
    .querySelectorAll(".product-thumb-container")
    .forEach((thumb) => {
      showElements(thumb);
    });

  setSelectedSizeImage();
};

const updateCTAs = (status, handle, radio) => {
  const addToCartButton = document.getElementById("pdp-atc");
  let isSizeSelected = false;
  let isSlitVariantSelected = false;
  const sizeRadios = document.querySelectorAll(".size-radio");
  const slitVariationRadios = document.querySelectorAll(
    ".slit-variation-radio",
  );
  const personalizationSelectors = document.querySelectorAll(
    ".personalization-input",
  );
  let isSizeAndSlitVariationSelected;
  sizeRadios.forEach((radio) => {
    if (radio.checked) {
      isSizeSelected = true;
      if (sessionStorage) {
        if (
          ["XS", "S", "M", "L", "XL", "XXL", "1X", "2X", "3X"].find(
            (size) => size === radio.value,
          )
        ) {
          sessionStorage.setItem("pdp-standard-size-preselect", radio.value);
        } else if (
          ["XS/S", "M/L", "XL/XXL", "1X/3X"].find(
            (size) => size === radio.value,
          )
        ) {
          sessionStorage.setItem(
            "pdp-standard-wide-size-preselect",
            radio.value,
          );
        } else if (
          ["SMALL", "MEDIUM", "LARGE"].find((size) => size === radio.value)
        ) {
          sessionStorage.setItem(
            "pdp-standard-full-size-preselect",
            radio.value,
          );
        } else if (
          [
            "5",
            "5.5",
            "6",
            "6.6",
            "7",
            "7.5",
            "8",
            "8.5",
            "9",
            "9.5",
            "10",
          ].find((size) => size === radio.value)
        ) {
          sessionStorage.setItem("pdp-number-size-preselect", radio.value);
        } else if (["A", "B", "C", "D"].find((size) => size === radio.value)) {
          sessionStorage.setItem("pdp-alphabet-size-preselect", radio.value);
        }
      }
    }
  });

  slitVariationRadios.forEach((radio) => {
    if (radio.checked) {
      isSlitVariantSelected = true;
    }
  });
  isSizeAndSlitVariationSelected =
    (sizeRadios.length && !isSizeSelected) ||
    (slitVariationRadios.length && !isSlitVariantSelected);
  if (status == "unavailable" || status == "none") {
    addToCartButton.disabled = true;
    addToCartButton.classList.remove("bis-cta", "button-primary-alt");
    if (status === "unavailable") {
      addToCartButton.innerText = "OUT OF STOCK";
      if (personalizationSelectors) {
        personalizationSelectors.forEach((selector) => {
          selector.disabled = true;
        });
      }
    } else {
      addToCartButton.innerText = `UNAVAILABLE`;

      if (sizeRadios.length && !slitVariationRadios.length) {
        if (isSizeSelected) {
          setUnavailable();
          status = "unavailable";
        }
      } else if (slitVariationRadios.length && !sizeRadios.length) {
        if (isSlitVariantSelected) {
          setUnavailable();
          status = "unavailable";
        }
      } else if (slitVariationRadios.length && sizeRadios.length) {
        if (isSlitVariantSelected && isSizeSelected) {
          setUnavailable();
          status = "unavailable";
        }
      } else {
        initialHandle = "none";
        setUnavailable();
      }
    }

    if (sizeRadios.length > 0 && status !== "unavailable") {
      addToCartButton.disabled = false;
      addToCartButton.innerText = `ADD TO BAG`;
      changeCtaTextForMtoAndPreorder();
      if (handle === "undefined") {
        setUnavailable();
      }
    }
  } else if (status === "waitlist") {
    addToCartButton.disabled = false;
    addToCartButton.classList.add("bis-cta", "button-primary-alt");
    addToCartButton.innerText = `ADD ME TO THE WAITLIST`;
  } else if (status === "preorder" || status === "available") {
    addToCartButton.disabled = false;
    addToCartButton.classList.remove("bis-cta", "button-primary-alt");
  } else if (status === "made-to-order") {
    addToCartButton.innerText = `Add To Bag`;
  }
  changeCtaTextForMtoAndPreorder();
  swapHex();

  const tagsToCheck = [
    /* names is an array of all accepted tags that correspond to a class in product--badges */
    { names: ["launching tag"], className: ".launching-tag" },
    { names: ["daily deal"], className: ".daily-deal-tag" },
    { names: ["Best Seller"], className: ".best-seller-tag" },
    { names: ["limited time price"], className: ".limited-time-price" },
    {
      names: ["Luxe", "luxe-matte satin"],
      className: ".luxe-matte-satin-tooltip-tag",
    },
    { names: ["luxe-premium"], className: ".luxe-premium-tooltip-tag" },
    { names: ["New Arrival"], className: ".new-arrival-tag" },
    { names: ["BMSMGR"], className: ".suite-looks-tag" },
    { names: ["BMSMWP"], className: ".tieoneon-tag" },
    { names: ["Discontinued"], className: ".discontinued-tag" },
    { names: ["Final Sale"], className: ".fnl-tag" },
  ];

  const productTags = JSON.parse(
    document.getElementById("product-tags")?.dataset.tags,
  );

  const hasLaunchingTag = productTags?.includes("badge:dresseslaunchingin");
  const hasFinalSaleTag =
    productTags?.includes("finalsale") || productTags?.includes("Final Sale");
  /* Luxe Matte Satin tooltip has support for product tags "Luxe" and "luxe-matte satin" */
  const hasLuxeMatteSatinTag =
    productTags?.includes("Luxe") || productTags?.includes("luxe-matte satin");
  const hasLuxePremiumTag = productTags?.includes("luxe-premium");
  const hasDiscontinuedTag = productTags?.includes("Discontinued");

  const toggleProductBadges = () => {
    tagsToCheck.forEach((tag) => {
      const shouldShowTag = hasLaunchingTag
        ? tag.names.includes("launching tag") ||
          (hasFinalSaleTag && tag.names.includes("Final Sale")) ||
          (hasLuxeMatteSatinTag && tag.names.includes("Luxe")) ||
          (hasLuxePremiumTag && tag.names.includes("luxe-premium")) ||
          (hasDiscontinuedTag && tag.names.includes("Discontinued"))
        : tag.names.some((name) => productTags?.includes(name));
      const targetTag = document.querySelector(tag.className);

      if (targetTag) {
        if (shouldShowTag) {
          targetTag.classList.remove("none");
        } else {
          targetTag.classList.add("none");
        }
      }
    });
  };

  toggleProductBadges();
  if (
    productTags?.includes("finalsale") ||
    productTags.includes("Final Sale")
  ) {
    if (
      productTags?.includes("Pajamas") ||
      productTags?.includes("Robes") ||
      productTags?.includes("Loungewear")
    ) {
      const fnlTag = document.querySelector(".fnl-tag");
      const fnlIcon = document.querySelector(".fnl-icon");

      if (
        document.querySelector('.product-radio[value="PERSONALIZED"]')
          ?.checked ||
        document.querySelector('.product-radio[value="FREE PERSONALIZATION"]')
          ?.checked
      ) {
        showElements(fnlTag, fnlIcon);
      } else {
        hideElements(fnlTag, fnlIcon);
      }
    }
  }

  if (isSizeAndSlitVariationSelected && isPersonalizationEnabled) {
    if (radio) {
      if (
        radio.value === "PERSONALIZED" ||
        radio.value === "FREE PERSONALIZATION"
      ) {
        if (status === "unavailable") {
          addToCartButton.innerText = `OUT OF STOCK`;
          if (personalizationSelectors) {
            personalizationSelectors.forEach((selector) => {
              selector.disabled = true;
            });
          }
        } else if (status === "waitlist") {
          addToCartButton.innerText = "ADD ME TO THE WAITLIST";
        } else {
          addToCartButton.innerText = "PERSONALIZE IT";
        }
        changeCtaTextForMtoAndPreorder();
        swapHex();
      }
    }
  }
};

/**
 * Returns the selected variant HTML Element.
 *
 * @returns {HTMLElement} The HTML element that represents the selected variant
 */
const getSelectedVariantElement = () => {
  const areAllOptionsSelected = allOptionsSelected();
  if (!areAllOptionsSelected) return;

  const selectElement = document.querySelector(".variant-select");
  const selectedVariant = selectElement.options[selectElement.selectedIndex];
  return selectedVariant;
};

/**
 * Generates the back in stock modal with updated variant data from the selected variant.
 * Modal is toggled to show during showBackInStockModal() function.
 *
 * @param {HTMLElement} selection - The HTML Element that represents the current selected variant
 * @returns {void}
 */
const generateBackInStockModalData = (selection) => {
  if (!selection) return;

  const backInStockSubmitButton = document.getElementById("bis-submit");
  const backInStockVariantTitle = document.getElementById("bis-variant-title");
  backInStockSubmitButton.dataset.variant = selection.value;
  backInStockSubmitButton.dataset.handle = selection.dataset.handle;
  backInStockSubmitButton.dataset.vartitle = selection.dataset.title;
  backInStockVariantTitle.innerText = selection.dataset.title.toLowerCase();
};

/**
 * Retrieves the value of a selected variant option from the DOM.
 * @param {string} selector - The CSS selector for the input elements.
 * @param {boolean} defaultToFirstAvailable - If true, defaults to the first available option if none are selected.
 * @returns {string|undefined} The value of the selected or default option.
 *
 * Todo: Make as util once product.js can be turned into module
 */
const getVariantOptionValue = (selector, defaultToFirstAvailable = false) => {
  const elements = document.querySelectorAll(selector);
  const checked = Array.from(elements).find((el) => el.checked);

  if (checked) {
    return checked.value;
  }
  if (defaultToFirstAvailable && elements.length > 0) {
    return elements[0].value;
  }
  return undefined;
};

/**
 * Checks the availability of a product variant and updates the UI of the PDP accordingly.
 * This function typically handles events such as clicks.
 * @param {Event} event - The event object, typically a click event.
 * @returns {void}
 */
const checkAvailability = (e) => {
  let radio;

  if (e.currentTarget) {
    radio = e.currentTarget;
  } else {
    radio = e;
  }

  if (radio.getAttribute("for")) {
    radio = document.getElementById(radio.getAttribute("for"));
  }

  const { handle } = radio.dataset;

  radio.checked = true;
  let status;
  const options = [];
  const optionObject = {};
  const names = [];
  const values = [];
  let price = 0;
  let comparePrice = 0;
  const radioButtons = document.querySelectorAll(`.radio-${handle}`);

  radioButtons.forEach((option) => {
    if (option.checked) {
      options.push({ name: option.name, value: option.value });
      names.push(option.name);
      values.push(option.value);
      optionObject[option.name] = option.value;
    }
  });

  const addToCartButton = document.getElementById("pdp-atc");
  const variants = [];
  const waitlisted = [];
  const select = document.getElementById(radio.dataset.select);
  const personalizationSelectors = document.querySelectorAll(
    ".personalization-input",
  );
  let selectString = ``;
  let selected = false;
  const selectionArray = [];
  let variantArrayForAjax;
  let changeProduct = false;
  let hex;

  if (select) {
    window.selectedSize = Array.from(radioButtons).filter(
      (button) =>
        button.checked && button.classList.value.includes("size-radio"),
    )[0];
    let variantString = "";
    const variantStringArray = [];
    for (let i = 0; i < names.length; i++) {
      variantStringArray.push(values[i]);
      selectionArray.push(values[i]);
    }
    variantString = variantStringArray.join(" / ").toUpperCase();
    variantArrayForAjax = variantStringArray;
    const mtoProductArray = [];
    select.querySelectorAll("option").forEach((value) => {
      const variantFullTitle = String(value.dataset.title);
      if (variantFullTitle.indexOf("MTO") > -1) {
        mtoProductArray.push(variantFullTitle);
      }

      /**
       * Check for a matching variant and update price, variantId, and availability.
       *
       * @param {HTMLElement} value - The HTML <option> element representing the variant.
       * @param {string} variantString - The string representing the value.dataset.title to find.
       *     This string is created by traversing the DOM in order and checking the value of each checked variant.
       *     Example: If the user has selected color and slit variation but not size -> "SEA GLASS / SLIT"
       *     Example: If the user has selected size, color, and slit variation -> "XS / SEA GLASS / SLIT"
       * @param {string} initialHandle - The initial handle of the product before changing variants.
       *     Used to mainly check if the color has changed and whether or not to update UI.
       */
      if (value.dataset.title) {
        const strippedVariantTitle = value.dataset.title
          .toUpperCase()
          .replaceAll("  ", " ");
        if (strippedVariantTitle === variantString) {
          selectString = value.dataset.title;
          variantId = value.value;
          value.selected = "selected";
          selected = true;
          // Do not update price if it's a suit item. Suit items use a single PDP for the price but we break into product grouping for jacket and pant sizing. To avoid updating the PDP price per variant selection, we're defaulting to the suit product pricing. If on sale, it will show the sale price of the suit PDP's price range.
          if (!value.dataset.productType.includes("Suit")) {
            price = value.dataset.price;
            if (value.dataset.compareprice) {
              comparePrice = Number(value.dataset.compareprice);
            }
          }
          if (value.dataset.handle) {
            if (value.dataset.handle !== initialHandle) {
              initialHandle = value.dataset.handle;
              changeProduct = true;
              if (value.dataset.hex) {
                hex = value.dataset.hex;
              }
            }
          }
        }
        if (!value.disabled && !value.classList.contains("unavailable")) {
          variants.push(value.dataset.title);
        } else if (value.disabled && !value.classList.contains("unavailable")) {
          waitlisted.push(value.dataset.title);
        }
      }
    });
    if (!selected && radio.dataset.handle != "swatch") {
      select.value = "none";
    }

    /**
     * Creates the product icons and grid from snippets/product--icons.liquid
     * This function is fired whenever a possible change to the icons occur
     * @param {HTMLElement} productIcons - The HTML parent element that holds are product icons
     */
    const generateProductIconsGrid = (productIcons) => {
      const icons = productIcons.querySelectorAll(".product-icon");
      let iconCount = 0;

      icons.forEach((icon) => {
        if (!icon.classList.contains("none")) {
          iconCount++;
        }
      });

      productIcons.classList.remove("dg4", "dg3", "dg2", "dg1", "mg2", "mg1");
      if (iconCount === 1) {
        productIcons.classList.add("dg1", "mg1");
      } else if (iconCount === 2) {
        productIcons.classList.add("dg2", "mg2");
      } else if (iconCount === 3) {
        productIcons.classList.add("dg2", "mg2");
      } else {
        productIcons.classList.add("dg2", "mg2");
      }
    };

    // Set initial product icons grid if it exists
    if (document.getElementById("product-icons")) {
      generateProductIconsGrid(document.getElementById("product-icons"));
    }

    // BEGIN Change UI on PDP for preorder,discountinued, back in stock and default whenswitching states
    document.querySelectorAll(".pdp-option").forEach((option) => {
      if (option.value === select.value && option.disabled && option.selected) {
        if (option.dataset.madetoorder) {
          if (document.getElementById("product-icons")) {
            generateProductIconsGrid(document.getElementById("product-icons"));
          }
          status = "made-to-order";
        } else {
          if (document.getElementById("product-icons")) {
            generateProductIconsGrid(document.getElementById("product-icons"));
          }
          status = "none";
        }
        if (option.dataset.nowaitlist === "true") {
          status = "unavailable";
        } else {
          status = "waitlist";
        }
      } else if (
        option.selected &&
        option.value === select.value &&
        !option.classList.contains("unavailable") &&
        !option.disabled
      ) {
        if (option.dataset.madetoorder) {
          status = "made-to-order";
          addToCartButton.disabled = false;
          addToCartButton.classList.remove("bis-cta", "button-primary-alt");
          addToCartButton.innerText = `Preorder`;
        }

        if (option.dataset.preorder && !option.dataset.madetoorder) {
          status = "preorder";
          addToCartButton.disabled = false;
          addToCartButton.classList.remove("bis-cta", "button-primary-alt");
          addToCartButton.innerText = `Preorder`;
          document.querySelector(
            "#preorder-text .preorder-arrive-note",
          ).innerText = `${option.dataset.preorder}`;
        } else if (option.dataset.madetoorder && mtoProductArray.length === 0) {
          if (document.getElementById("product-icons")) {
            generateProductIconsGrid(document.getElementById("product-icons"));
          }
        } else {
          status = "available";
          if (document.getElementById("product-icons")) {
            generateProductIconsGrid(document.getElementById("product-icons"));
          }
          addToCartButton.innerText = `ADD TO BAG`;
          addToCartButton.disabled = false;
          addToCartButton.classList.remove("bis-cta", "button-primary-alt");
          const variantStringIncludesPersonalization =
            (variantString.includes("PERSONALIZED") ||
              variantString.includes("FREE PERSONALIZATION")) &&
            !variantString.includes("NOT PERSONALIZED") &&
            isPersonalizationEnabled;

          if (variantStringIncludesPersonalization) {
            if (status === "unavailable") {
              addToCartButton.innerText = `OUT OF STOCK`;
              if (personalizationSelectors) {
                personalizationSelectors.forEach((selector) => {
                  selector.disabled = true;
                });
              }
            } else if (status === "waitlist") {
              addToCartButton.innerText = "ADD ME TO THE WAITLIST";
            } else {
              addToCartButton.innerText = "PERSONALIZE IT";
            }
          } else {
            addToCartButton.innerText = `ADD TO BAG`;
          }
        }
        changeCtaTextForMtoAndPreorder();
        swapHex();
      }
    });
  }

  // END Change UI Text for buttons and on PDP for preorder,discountinued, back in stock and default whenswitching states
  const sizeRadios = document.querySelectorAll(".size-radio");
  const slitVariationRadios = document.querySelectorAll(
    ".slit-variation-radio",
  );
  let isSizeSelected = false;
  let isSlitVariantSelected = false;
  let isSizeAndSlitVariationSelected;

  sizeRadios.forEach((radio) => {
    if (radio.checked) {
      isSizeSelected = true;
    }
  });
  slitVariationRadios.forEach((radio) => {
    if (radio.checked) {
      isSlitVariantSelected = true;
    }
  });
  isSizeAndSlitVariationSelected =
    (sizeRadios.length && !isSizeSelected) ||
    (slitVariationRadios.length && !isSlitVariantSelected);

  document.querySelectorAll(`.radio-${handle}`).forEach((option) => {
    let variantString = "";
    const variantStringArray = [];
    const label = document.querySelector(`label[for="${option.id}"]`);
    const current = JSON.parse(JSON.stringify(optionObject));
    const { name } = option;
    const { value } = option;
    current[`${name}`] = value;

    for (let i = 0; i < names.length; i++) {
      variantStringArray.push(current[names[i]]);
    }

    const isEstimatedArrival = option.classList.contains(
      "estimated-arrival-input",
    );

    variantString = variantStringArray.join(" / ").toUpperCase();

    if (variants.includes(variantString)) {
      option.disabled = false;
      option.classList.remove("waitlisted");
    } else if (isEstimatedArrival) {
      /**
       * When the variant selector is estimated arrival, disable the rush variant selector.
       */
      if (waitlisted.includes(variantString)) {
        const optionValue = option.value.toLowerCase();
        const lowerCasedRushOptionName =
          window.dualSaleRushOptionName.toLowerCase();
        const optionIsRushVariant = optionValue === lowerCasedRushOptionName;
        if (optionIsRushVariant) {
          option.disabled = true;
        }
        option.classList.add("waitlisted");
      } else {
        option.disabled = false;
      }
    } else if (waitlisted.includes(variantString)) {
      option.disabled = false;
      option.classList.add("waitlisted");
    } else if (isSizeAndSlitVariationSelected) {
      option.disabled = false;
    } else {
      option.classList.remove("waitlisted");
    }
  });

  if (select?.value == "none") {
    status = "none";
    addToCartButton.disabled = true;
    if (sizeRadios.length && !slitVariationRadios.length) {
      if (isSizeSelected) {
        addToCartButton.innerText = "UNAVAILABLE";
      }
    } else if (slitVariationRadios.length && !sizeRadios.length) {
      if (isSlitVariantSelected) {
        addToCartButton.innerText = "UNAVAILABLE";
      }
    } else if (slitVariationRadios.length && sizeRadios.length) {
      if (isSlitVariantSelected && isSizeSelected) {
        addToCartButton.innerText = "UNAVAILABLE";
      }
    }
    addToCartButton.classList.remove("bis-cta", "button-primary-alt");
    price = select.options[select.selectedIndex].dataset.price;
    let varString = ``;
    document.querySelectorAll(".size-radio").forEach((size) => {
      if (size.checked) {
        varString = size.value;
      }
    });
    if (sizeRadios && !isSizeSelected) {
      document
        .querySelectorAll(".personalization-input")
        .forEach((personalization) => {
          if (personalization.checked) {
            varString = personalization.value;
          }
        });
    }
    document.querySelectorAll(".color-radio").forEach((color) => {
      if (color.checked) {
        if (varString.length > 0) {
          varString += ` / ${color.value}`;
        } else {
          varString = color.value;
        }
      }
    });
    select.querySelectorAll("option").forEach((value) => {
      if (value.dataset.title) {
        if (value.dataset.title.includes(varString)) {
          if (value.dataset.compareprice) {
            comparePrice = Number(value.dataset.compareprice);
          }
        }

        const whiteSpaceRemovedTitle = value.dataset.title
          .split(" / ")[1]
          .replace(/\s+/g, "");
        const whiteSpaceRemovedVarString = varString.split(" / ")[1]
          ? varString.split(" / ")[1].replace(/\s+/g, "")
          : varString.replace(/\s+/g, "");
        let whiteSpaceRemovedTitleForPrice;
        let whiteSpaceRemovedVarStringForPrice;
        let productIsPersonalizable;

        if (sizeRadios && !isSizeSelected) {
          document
            .querySelectorAll(".personalization-input")
            .forEach((personalization) => {
              if (personalization.checked) {
                productIsPersonalizable = true;
                whiteSpaceRemovedTitleForPrice = value.dataset.title
                  .split("/")
                  .find((el) => el.indexOf("PERSONALIZED") !== -1);

                if (whiteSpaceRemovedTitleForPrice) {
                  whiteSpaceRemovedTitleForPrice =
                    whiteSpaceRemovedTitleForPrice.replace(/\s+/g, "");
                } else {
                  whiteSpaceRemovedTitleForPrice = value.dataset.title
                    .split("/")
                    .find((el) => el.indexOf("FREE PERSONALIZATION") !== -1)
                    .replace(/\s+/g, "");
                }
                whiteSpaceRemovedVarStringForPrice = varString
                  .split("/")[0]
                  .replace(/\s+/g, "");
              }
            });

          // Takes current product and compares it to all possible variant combinations
          // If a match is found where varString is included in the product's title, the price is updated

          const wordsInTitle = value.dataset.title.split(/\s+/);

          if (
            // varString is 1 word that is included in wordsInTitle
            (varString.split(/\s+/).length === 1 &&
              wordsInTitle.includes(varString) &&
              !wordsInTitle.some((word) => word !== varString)) ||
            // varString is more than 1 word where all words match possbile words in wordsInTitle
            (varString.split(/\s+/).length > 1 &&
              varString
                .split(/\s+/)
                .every((word) => wordsInTitle.includes(word))) ||
            productIsPersonalizable
          ) {
            if (
              whiteSpaceRemovedVarStringForPrice ===
              whiteSpaceRemovedTitleForPrice
            ) {
              price = value.dataset.price;
            }
          }
        }
        if (whiteSpaceRemovedTitle === whiteSpaceRemovedVarString) {
          if (
            (sizeRadios && !isSizeSelected) ||
            (slitVariationRadios && !isSlitVariantSelected)
          ) {
            if (value.dataset.handle !== initialHandle) {
              initialHandle = value.dataset.handle;

              changeProduct = true;
              if (value.dataset.hex) {
                hex = value.dataset.hex;
              }
            }
          } else if (value.dataset.handle !== initialHandle) {
            initialHandle = value.dataset.handle;

            changeProduct = true;
            if (value.dataset.hex) {
              hex = value.dataset.hex;
            }
          }
          price = value.dataset.price;
        }
      }
    });
  }
  changeCtaTextForMtoAndPreorder();
  swapHex();

  handleSellingFast("none");
  const atc = document.getElementById("pdp-atc");
  let announcement = ``;
  if (atc.innerText.toLowerCase().trim() === "preorder") {
    announcement += `<p>The variant ${selectString} is a preorder and is ${preOrderNote.innerText.replace("*", "")}</p>`;
  } else if (atc.classList.contains("bis-cta")) {
    announcement += `<p>The variant ${selectString} isn't in stock, but you can sign up for the waitlist.</p>`;
  }
  if (announcement.length > 0) {
    document.getElementById("screen-announcements").innerHTML = announcement;
  }

  const priceContainer = document.getElementById("product-price");
  comparePrice = Number(comparePrice);
  price = Number(price);

  const personalizationFieldset = document.querySelector(
    ".personalization-fieldset-container",
  );

  if (personalizationFieldset) {
    /**
     * If the personalization option exists, we check if size isn't selected.
     * If so, we use the first variant to base pricing off of.
     *
     * The first variant is the first to match the current selected personalization and color.
     */
    const selectedSize = document
      .querySelector(".size-dropdown")
      ?.getAttribute("value");

    if (!selectedSize) {
      /**
       * We grab the selected personalization and color to querySelect it from the product's variant-select element.
       */
      const selectedPersonalization = getVariantOptionValue(
        ".personalization-input",
        true,
      );
      const selectedColor = getVariantOptionValue(
        ".standard-color-radios input",
        false,
      );

      /**
       * Get the first variant that matches the personalization and color.
       * Then assign the new price data based off it's data attributes.
       */
      const firstVariant = document.querySelector(
        `.variant-select [data-title*="${selectedColor} / ${selectedPersonalization}"]`,
      );

      if (firstVariant) {
        comparePrice = Number(firstVariant.dataset.compareprice);
        price = Number(firstVariant.dataset.price);
      }
    }
  }

  if (price) {
    if (price > comparePrice && comparePrice > 0) {
      const originalPrice =
        price % 100 > 0 ? (price / 100).toFixed(2) : price / 100;
      const salePrice =
        comparePrice % 100 > 0
          ? (comparePrice / 100).toFixed(2)
          : comparePrice / 100;

      priceContainer.innerHTML = `
        <span
          aria-label="Original price $${originalPrice}"
          class="text-brand-darkerMocha decoration-2 line-through"
        >
          <span class="text-brand-deepMocha-75">$${originalPrice}</span>
        </span>
        <span
          aria-label="Sale price $${salePrice}"
          class="text-brand-darkerMocha"
        >
          $${salePrice}
        </span>
      `;
    } else {
      if (radio && radio.dataset.handle == "swatch") {
        setSwatchPricePDP(price, priceContainer, "swatch");
      }

      // Gift cards
      if (radio && radio.dataset.handle === "digital-gift-card") {
        const newPriceElement = priceContainer.cloneNode(true);
        const formatPrice = (priceToFormat) =>
          `$${(priceToFormat / 100).toFixed(priceToFormat % 100 > 0 ? 2 : 0)}`;

        newPriceElement.innerHTML = formatPrice(price);
        priceContainer.replaceWith(newPriceElement);
      }

      // Check for updating personalizable product price
      if (personalizationSelectors?.length && status !== "unavailable") {
        priceContainer.innerHTML = `$${
          price % 100 > 0 ? (price / 100).toFixed(2) : price / 100
        }`;
      }
    }
  }

  const personalizationModal = document.getElementById(
    "personalizer-container",
  );

  setSelectedSizeImage();
  updateCTAs(status, null, radio);
  resetProductGalleryImages(status);

  // This helps reset the Monogram/Personalization Component admin-only preview button.
  const adminPreviewBtn = document.querySelector(
    ".preview-modal-btn.admin-only",
  );
  if (adminPreviewBtn)
    adminPreviewBtn.addEventListener(
      "click",
      window.renderPersonalizationModal,
    );

  if (
    personalizationModal &&
    status !== "unavailable" &&
    status !== "waitlist"
  ) {
    const arrayIncludesPersonalization =
      selectionArray.includes("PERSONALIZED") ||
      selectionArray.includes("FREE PERSONALIZATION");
    if (arrayIncludesPersonalization) {
      personalizationModal.style.display = "block";
      document.querySelectorAll(".personalization-radio").forEach((radio) => {
        radio.disabled = false;
      });
      const openPersonalizationModal = () => {
        addToCartButton.innerText = `PERSONALIZE IT`;
        addToCartButton.removeEventListener("click", atcClick);
        addToCartButton.addEventListener(
          "click",
          window.renderPersonalizationModal,
        );
      };
      // Check if there are multiple sizes: If there are, do not allow modal to open unless Size is Selected
      if (sizeRadios.length) {
        if (isSizeSelected) openPersonalizationModal();
      } else {
        // Else, open the modal (e.g. shawls/accessories)
        openPersonalizationModal();
      }
    } else {
      personalizationModal.style.display = "none";
      document.querySelectorAll(".personalization-radio").forEach((radio) => {
        radio.disabled = true;
      });
      addToCartButton.removeEventListener(
        "click",
        window.renderPersonalizationModal,
      );
      addToCartButton.removeEventListener("click", atcClick);
      addToCartButton.addEventListener("click", atcClick);
    }
  } else {
    if (personalizationModal) {
      addToCartButton.removeEventListener(
        "click",
        window.renderPersonalizationModal,
      );
    }
    addToCartButton.removeEventListener("click", atcClick);
    addToCartButton.addEventListener("click", atcClick);
  }

  document.getElementById("bis-confirmation-message").style.display = "none";
  document.getElementById("bis-form-area").style.display = "block";
  document.getElementById("bis-email").value = ``;
  document.getElementById("bis-email").classList.remove("invalid-input");

  // Multiple Sizes/Slit Options
  if (sizeRadios.length) {
    const radiosIncludePersonalization =
      (radio.value && radio.value === "PERSONALIZED") ||
      (radio.value && radio.value === "FREE PERSONALIZATION");
    if (radiosIncludePersonalization) {
      if (isSizeSelected) {
        // Open modal if a size variation is chosen
        if (status === "unavailable") {
          addToCartButton.innerText = `OUT OF STOCK`;
          if (personalizationSelectors) {
            personalizationSelectors.forEach((selector) => {
              selector.disabled = true;
            });
          }
        } else if (status === "waitlist") {
          addToCartButton.innerText = "ADD ME TO THE WAITLIST";
        } else {
          addToCartButton.innerText = "PERSONALIZE IT";
        }
      }
      changeCtaTextForMtoAndPreorder();
      swapHex();
    }
  }

  /**
   * Update back in stock modal's submit button dataset with selected variant information.
   *
   * We don't need to worry about showing or hiding the modal here as that's handled by showBackInStockModal()
   * */
  const selectedVariant = getSelectedVariantElement();
  if (selectedVariant) generateBackInStockModalData(selectedVariant);
};

const getSwatchUpsells = (tags, title) => {
  let name = title.split("-");
  name = name[1];
  name = name.split(" in ");
  const searchString = `product_type:"Bridesmaid Dress"+AND+tag:"${name[0].trim()}"+AND+tag:"${name[1].trim()}"`;
  const host = window.location.hostname;
  fetch(
    `https://${host}/search?view=dictionary&type=product&q=${searchString}`,
    { method: "GET" },
  )
    .then((res) => res.text())
    .then((response) => {
      let rawJson = "";
      let upsells = [];
      try {
        const match = response.match(/let products = (.*)<\/script>/s);
        if (!match || !match[1])
          throw new Error("No se encontró 'let products ='");

        rawJson = match[1].trim();

        // Limpieza de caracteres de control (menos saltos de línea, tabs, etc.)
        const cleanedJson = rawJson.replace(
          /[\u0000-\u001F\u007F]/g,
          (char) => {
            if (char === "\n" || char === "\r" || char === "\t") return "";
            return "";
          },
        );

        upsells = JSON.parse(cleanedJson);
      } catch (err) {
        console.error(" upsells error :", err);
        console.log("Partial content:", response.slice(0, 300));
        return;
      }
      let picked = [];
      picked = shuffle(upsells);
      let upsellContainer = ``;
      let upsellWrapper = document.getElementById("cross-sell-upsell-wrapper");

      if (picked.length) {
        picked.forEach((upsell, index) => {
          if (upsell.available === "true") {
            const name = upsell.title.split("-");
            let title = `<div>${name[0]}</div>`;
            if (upsell.type === "Bridesmaid Dress") {
              title = `<div>${name[0]
                .replace("Crepe ", "")
                .replace("Satin ", "")
                .replace("Shiny ", "")
                .replace("Matte ", "")
                .replace("Chiffon ", "")
                .replace("Velvet ", "")
                .replace("Mesh ", "")
                .replace("Tulle ", "")}</div>`;
            }
            let subtitle = ``;
            if (name.length > 1) {
              let fabric = "";
              if (upsell.type !== "Swatch" && upsell.type !== "Face Mask") {
                const fabricMap = {
                  chiffon: "Chiffon",
                  tulle: "Tulle",
                  mesh: "Mesh",
                  crepe: "Crepe",
                  "shiny satin": "Shiny Satin",
                  "matte satin": "Matte Satin",
                  satin: "Shiny Satin",
                  velvet: "Velvet",
                  "luxe knit": "Luxe Knit",
                };

                const fabricTag = upsell.tags.find(
                  (tag) =>
                    tag.toLowerCase().startsWith("fabric:") ||
                    fabricMap[tag.toLowerCase()],
                );

                if (fabricTag) {
                  const fabricType = fabricTag
                    .toLowerCase()
                    .replace("fabric:", "")
                    .trim();
                  fabric =
                    fabricMap[fabricType] ||
                    fabricType.charAt(0).toUpperCase() + fabricType.slice(1);
                }
              }

              subtitle = `<div class="regular">${fabric} ${name[1].replace(" in ", " ")}</div>`;
            }

            upsellContainer += `
            <div class="pointer carousel-item flex snap-start w-[calc(100%/2-(0.75rem/2))] md:w-[calc(100%/3.75-0.75rem)] lg:w-[calc(100%/4.75-0.75rem)]  shrink-0">
              <a class="no-underline" href="${upsell.url}">
            <div>
            <picture>
              <source media="(max-width:480px)" srcset="${upsell.images[0].src.replace("1600x1600", "480x480")}">
              <source media="(min-width:481px) and (max-width:768px)" srcset="${upsell.images[0].src.replace("1600x1600", "768x768")}">
                <source media="(min-width:769px)" srcset="${upsell.images[0].src.replace("1600x1600", "900x900")}">
                  <img alt="" width="${upsell.images[0].width}" height="${upsell.images[0].height}" loading="lazy" class="object-cover" src="${upsell.images[0].src}">
            </picture>
            </div>
            <div class="flex text-xs md:text-sm lh14 justify-between my-1 mx-0">
            <div class="text-left capitalize bold">${title}${subtitle}</div>
            <div class="font-semibold">${
              upsell.compare_at_price &&
              Number(upsell.price.slice(1)) >
                Number(upsell.compare_at_price.slice(1))
                ? `<div class="text-brand-darkerMocha line-through decoration-2"><span class="text-brand-deepMocha-75">${upsell.price}</span></div><div class="text-brand-darkerMocha">${upsell.compare_at_price}</div>`
                : upsell.price
            }
            </div>
          </div>
            </a>
        </div>
        `;
          }
        });
        upsellWrapper.classList.remove("hidden");
        document.getElementById("swatch-upsell-carousel").innerHTML =
          upsellContainer;
      } else {
        upsellWrapper.classList.add("hidden");
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

const setUnavailable = () => {
  let title = document.getElementById("product-title").innerText.toLowerCase();
  let subtitle = [];
  let finalTitle = ``;
  let fabric = ``;

  const swatchSelector = document.querySelectorAll(".add-color-swatch");
  if (swatchSelector.length) {
    swatchSelector.forEach((selector) => {
      selector.classList.add("none");
    });
  }
  const source = document.getElementById("no-image-container").dataset.image;
  document.getElementById("product-main").src = source;
  const videoContainer = document.getElementById("product-video-container");
  if (videoContainer) {
    videoContainer.classList.add("none");
  }
  const mainImageContainer = document.getElementById(
    "product-main-image-container",
  );
  if (mainImageContainer) {
    mainImageContainer.classList.remove("none");
  }

  const productGallery = document.getElementById("product-gallery");
  productGallery
    .querySelectorAll(".product-thumb-container")
    .forEach((thumb) => {
      // Hide all images except the unavailable image
      if (!thumb.classList.contains("unavailable-image")) hideElements(thumb);
    });

  const unavailableImageElement = document.querySelector(".unavailable-image");

  /**
   * Since the customer can click on another unavailable product,
   *
   * we only add the unavailable image if it doesn't already exist.
   * */
  if (!unavailableImageElement) {
    const unavailableImage = `
    <div class="product-thumb-container pdp-thumb unavailable-image">
      <img loading="eager" class="product-thumb pointer" alt="unavailable product" width="800" height="800"
      data-full="${source}" src="${source}" />
    </div>
  `;

    productGallery.insertAdjacentHTML("afterbegin", unavailableImage);
  }

  setMainImageToFirstInGallery();

  title = document.getElementById("product-title").innerText.toLowerCase();
  subtitle = [];
  finalTitle = ``;
  fabric = ``;

  document.querySelectorAll(".variant-radio").forEach((button) => {
    if (button.checked) {
      subtitle.push(button.value);
    }
  });
  if (title.includes("dress")) {
    const currentSubtitle = document
      .querySelector(".product-subtitle")
      .innerText.split(" ");
    const color = subtitle[1];
    const fabric = currentSubtitle[0];
    finalTitle = `${fabric} ${color}`;
  }
};

const handleSellingFast = (response) => {
  const select = document.querySelector(".variant-select");
  const option = select.options[select.selectedIndex];
  let productType = null;
  if (response === "none") {
    productType = option.dataset.productType;
  } else {
    productType = response.type;
  }
  let currentColor;
  // Find current selected color
  const colors = standardColorRadios?.querySelectorAll("div input");
  colors?.forEach((color) => {
    if (color.checked) {
      currentColor = color;
    }
  });
  const variantMap = [];
  let mtoVariantExists = false;

  select.querySelectorAll("option").forEach((option) => {
    const { title } = option.dataset;
    if (title && currentColor != null) {
      if (title.includes(currentColor.value)) {
        variantMap.push(option.dataset.variantInventory);

        if (
          option.dataset.madetoorder != undefined ||
          option.dataset.preorder != undefined
        ) {
          mtoVariantExists = true;
        }
      }
    }
  });

  const sellingFast = document.querySelectorAll(".selling-fast");
  let showSellingFast = false;
  let inventoryThreshold = 0;
  if (mtoVariantExists === false && productType != null) {
    if (
      productType === "Bridesmaid Dress" ||
      productType === "Groomsmen Accessory" ||
      productType === "Getting Ready"
    ) {
      if (productType === "Bridesmaid Dress") {
        inventoryThreshold = 5;
      } else {
        inventoryThreshold = 10;
      }
      if (productType != "Getting Ready") {
        variantMap.every((value) => {
          if (value > 0 && value < inventoryThreshold) {
            showSellingFast = true;
            return false;
          }
          return true;
        });
      }
    }
  }

  if (showSellingFast === true) {
    sellingFast.forEach((tag) => {
      tag.classList.remove("none");
    });
  } else {
    sellingFast.forEach((tag) => {
      tag.classList.add("none");
    });
  }

  // handle only a few left
  const onlyAFewLeft = document.querySelector(".only-a-few-left");
  if (mtoVariantExists === false) {
    if (
      option.dataset.variantInventory > 0 &&
      option.dataset.variantInventory < inventoryThreshold
    ) {
      onlyAFewLeft.classList.remove("none");
    } else {
      onlyAFewLeft.classList.add("none");
    }
  } else {
    onlyAFewLeft.classList.add("none");
  }
};

const clickLabel = (e) => {
  const inputId = e.currentTarget.id;
  e.currentTarget.checked = true;
  const label = document.querySelector(`label[for="${inputId}"]`);
  label.click();
  checkAvailability(e);
};

// BEGIN BIS
const showBackInStockModal = () => {
  const container = document.getElementById("bis-input-container");
  container.classList.remove("hidden");
  container.setAttribute("aria-hidden", "false");
  container.setAttribute("aria-modal", "true");
  document
    .getElementById("website-content")
    .setAttribute("aria-hidden", "true");
  container.classList.remove("invisible");
  document.getElementById("bis-section").focus();
  window.toTrap = container;
  window.addEventListener("keydown", focusTrap);
  setTimeout(() => {
    document
      .querySelector("body")
      .addEventListener("click", closeBackInStockModal);
  }, 20);
};

const closeBackInStockModal = (e) => {
  const container = document.getElementById("bis-input-container");
  const modal = document.getElementById("bis-input-body");

  if (
    e.currentTarget.classList.contains("close-bis") ||
    !modal.contains(e.target)
  ) {
    document
      .querySelector("body")
      .removeEventListener("click", closeBackInStockModal);
    container.setAttribute("aria-hidden", "true");
    container.setAttribute("aria-modal", "false");
    document
      .getElementById("website-content")
      .setAttribute("aria-hidden", "false");
    container.classList.remove("invisible");
    window.removeEventListener("keydown", focusTrap);
    focusReturn.focus();
    container.classList.add("hidden");
  }
};
// END BIS

// Begin BIS
const submitBis = async (e) => {
  // DEACTIVATE THE BUTTON
  const button = e.currentTarget;
  const input = document.getElementById("bis-email");
  const { variant, handle } = e.currentTarget.dataset;
  const email = input.value;
  const verified = verifyInput(input);
  if (verified) {
    button.removeEventListener("click", submitBis);
    button.innerText = `SIGNING UP...`;

    const waitlistProduct = await fetch(`/products/${handle}.js`).then((res) =>
      res.json(),
    );

    const waitlistVariant = waitlistProduct.variants.find(
      (v) => v.id === Number.parseInt(variant),
    );

    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email,
              },
            },
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variant}`,
            },
          },
        },
      },
    };

    fetch(
      "https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=P5jJ7X",
      {
        headers: {
          accept: "application/json",
          revision: "2024-06-15",
          "content-type": "application/json",
        },
        body: JSON.stringify(payload),
        method: "POST",
      },
    )
      .then(async (res) => {
        let json = {};

        if (
          res.headers.get("content-type")?.includes("json") ||
          res.headers.get("content-type")?.includes("javascript")
        ) {
          json = await res.json();
        }

        if (!res.ok) {
          throw new Error(json.message || res.statusText || res.status);
        }
        return json;
      })
      .then(() => {
        document.getElementById("bis-form-area").style.display = "none";
        document.getElementById("bis-confirmation-message").style.display =
          "block";
        button.innerText = "SIGN UP";
        button.addEventListener("click", submitBis);

        const newBis = {
          event: "bis_signup",
          bis_product: product,
          bis_variant: variant,
          ...getAttributionData(),
        };
        gtag(newBis);
        trackAddToWaitlist(waitlistProduct, waitlistVariant, email);
      })
      .catch((err) => {
        console.error(err);
      });
  } else {
    input.classList.add("invalid-input");
  }
};

// END BIS

showProductGalleryButtons = (e) => {
  const productGallery = document.getElementById("product-gallery");
  const mainImageContainer = document.getElementById(
    "product-main-image-container",
  );
  if (
    onDesktop &&
    productGallery.offsetHeight > mainImageContainer.offsetHeight &&
    !isMobile.matches
  ) {
    e.currentTarget
      .querySelectorAll(".product-image-button")
      .forEach((button) => {
        button.style.height = `2rem`;
      });
  }
};

hideProductGalleryButtons = (e) => {
  e.currentTarget
    .querySelectorAll(".product-image-button")
    .forEach((button) => {
      button.style.height = `0`;
    });
};

const scrollToReviews = (e) => {
  e.preventDefault();
  const seeWhatOthersHadToSay = document.getElementById(
    "see-what-others-had-to-say",
  );
  const siteHeader = document.getElementById("shopify-section-header");
  const siteHeaderHeight = siteHeader.offsetHeight;
  const bufferHeight = 50;
  const pos = seeWhatOthersHadToSay.offsetTop - siteHeaderHeight - bufferHeight;
  window.scrollTo(0, pos);
};

function swapHex() {
  if (document.getElementById("pdp-atc")) {
    const addToCartButton = document.getElementById("pdp-atc");
    const addToCartButtonText = document
      .getElementById("pdp-atc")
      ?.textContent.trim()
      .toLowerCase();

    addToCartButton.classList.remove(
      "button-primary",
      "button-primary-alt",
      "button-secondary",
      "button-special",
    );

    const isSpecialButton =
      addToCartButtonText === "preorder" ||
      addToCartButtonText === "personalize it";

    // Update color based on arrival state
    if (isSpecialButton) {
      addToCartButton.classList.add("button-special");
    } else {
      addToCartButton.classList.add("button-primary");
    }
  }
}

function changeCtaTextForMtoAndPreorder() {
  const areAllOptionsSelected = allOptionsSelected();
  if (!areAllOptionsSelected) {
    if (window.globalAllSizesArePreorder) {
      const addToCartButton = document.getElementById("pdp-atc");
      const addToCartButtonText = document.getElementById("pdp-atc").innerText;
      addToCartButton.classList.remove(
        addToCartButton.classList.value
          .split(" ")
          .find((cssClass) => cssClass.indexOf("bg-") !== -1),
      );
      document.getElementById("pdp-atc").textContent = "Preorder";
    }
  }
}

const swapColorText = (e) => {
  if (e.type === "mouseenter") {
    document.querySelectorAll(".color-radio").forEach((radio) => {
      const select = document.querySelector(".variant-select");
      const option = select.options[select.selectedIndex];
    });
  } else if (e.type === "mouseleave") {
    document.querySelectorAll(".color-radio").forEach((radio) => {
      if (radio.checked) {
        const label = radio.nextElementSibling;
      }
    });
  }
};

/* if allOptionsSelected returns true, we know we can look directly at a product's dataset */
function allOptionsSelected() {
  /* slitVariationRadios are the "NO SLIT" and "SLIT" options for dresses, or any other radios that are titled "Variation" */
  const slitVariationRadios = document.querySelectorAll(
    ".slit-variation-radio",
  );

  /* sizeRadios are the S, M, L etc. options for products with size selectors */
  const sizeRadios = document.querySelector(".size-radios");
  let isSlitVariantSelected = false;
  let isSizeSelected = false;

  /* Check if slitVariationRadios exist and if a radio is selected, if not treat this option as true */
  if (slitVariationRadios.length) {
    isSlitVariantSelected = [...slitVariationRadios].some(
      (radio) => radio.checked,
    );
  } else {
    isSlitVariantSelected = true;
  }

  /* Check if sizeRadios exist and if a radio is selected, if not treat this option as true */
  if (sizeRadios) {
    if (sizeRadios.querySelector(".size-radio:checked")) {
      isSizeSelected = true;
    }
  } else {
    isSizeSelected = true;
  }

  return isSizeSelected && isSlitVariantSelected;
}

function initProduct() {
  // Initiate videos in product gallery
  document.querySelectorAll(".product-video-thumb").forEach((thumb) => {
    thumb.addEventListener("click", showVideo);
    // thumb.addEventListener('keydown', enterEvent);
  });

  document.addEventListener("click", (event) => {
    if (
      event.target &&
      event.target.classList.contains("product-thumb") === true
    ) {
      swapDesktopImage(event.target);
    }
  });

  // CHECK AVAILABILITY RADIO BUTTONS
  if (window.location.pathname.indexOf("products/swatch") !== -1) {
    checkAvailability(document.querySelector(".product-circle-radio:checked"));
    document.addEventListener("cartChange", () => {
      checkAvailability(
        document.querySelector(".product-circle-radio:checked"),
      );
    });
  }

  if (window.location.pathname.indexOf("products/suits-swatch-book") !== -1) {
    const priceContainer = document.getElementById("product-price");
    setSwatchPricePDP(200, priceContainer, "swatch-book");
    document.addEventListener("cartChange", () => {
      const priceContainer = document.getElementById("product-price");
      setSwatchPricePDP(200, priceContainer, "swatch-book");
    });
  }

  document.querySelectorAll(".product-radio-label").forEach((radio) => {
    radio.addEventListener("click", checkAvailability);
  });

  document.querySelectorAll(".variant-radio").forEach((input) => {
    input.addEventListener("change", clickLabel);
  });

  if (document.getElementById("see-it-in-the-wild-content")) {
    buildSeeItInTheWild();
  }

  const mainImageContainer = document.getElementById(
    "product-main-image-container",
  );
  if (mainImageContainer) {
    let currentImage;
    let zoomContainer = document.getElementById("zoom-container");
    let imageWidth;
    let imageHeight;
    let zoomFactor;
    let zoomImage = document.getElementById("zoom-image");
    window.scrollPosition = window.scrollY;
    const images = [];
    const preload = [];
    document.querySelectorAll(".product-image").forEach((container) => {
      const image = container.querySelector("img");
      images.push(image.src);
      images.push(image.src);
    });

    for (let i = 0; i < images.length; i++) {
      preload[i] = new Image();
      preload[i].src = images[i];
    }

    // Product Gallery Desktop Zoom Feature
    const zoomEnter = (e) => {
      if (onDesktop) {
        if (zoomContainer.classList.contains("is-fading")) {
          zoomContainer.classList.remove("is-fading");
        }

        imageWidth = mainImageContainer.offsetWidth;
        imageHeight = mainImageContainer.offsetHeight;
        zoomFactor =
          Math.round(
            (e.currentTarget.querySelector("img").getAttribute("width") /
              imageWidth) *
              100,
          ) / 100;
        zoomImage = document.getElementById("zoom-image");
        zoomedImage = document.getElementById("zoomed-image");
        zoomContainer.style.height = `${imageHeight + 1}px`;
        document.getElementById("zoom-overlay").style.width = `${
          imageWidth / zoomFactor
        }px`;
        document.getElementById("zoom-overlay").style.height = `${
          imageHeight / zoomFactor
        }px`;
        currentImage = e.currentTarget.querySelector("img").src;
        zoomContainer.style.display = "block";
        zoomedImage.src = currentImage;
        zoomContainer = document.getElementById("zoom-container");
        const aspectHeight = imageHeight / imageWidth;
        zoomContainer.style.height = `${
          zoomContainer.offsetWidth * aspectHeight
        }px`;
        document.getElementById("zoomed-image").style.width = `${
          zoomFactor * zoomContainer.offsetWidth
        }px`;

        setTimeout(() => {
          zoomImage.style.opacity = 1;
          document.getElementById("zoom-overlay").style.opacity = 1;
        }, 5);
      }
    };

    const zoomLeave = (e) => {
      if (onDesktop) {
        zoomContainer = document.getElementById("zoom-container");
        zoomContainer.classList.add("is-fading");

        zoomImage = document.getElementById("zoom-image");
        zoomImage.style.opacity = 0;
        document.getElementById("zoom-overlay").style.opacity = 0;
        setTimeout(() => {
          if (zoomContainer.classList.contains("is-fading")) {
            zoomContainer.style.display = "none";
            zoomContainer.classList.remove("is-fading");
          }
        }, 350);
      }
    };

    const zoomMove = (e) => {
      if (onDesktop) {
        zoomContainer = document.getElementById("zoom-container");
        if (zoomContainer.classList.contains("is-fading")) {
          zoomContainer.classList.remove("is-fading");
        }
        const zoomedImage = document.getElementById("zoomed-image");
        const scaleFactor =
          zoomContainer.offsetWidth / e.currentTarget.offsetWidth;
        let zoomLeft = Math.abs(
          e.pageX - mainImageContainer.getBoundingClientRect().left,
        );
        let zoomTop = Math.abs(
          e.pageY -
            mainImageContainer.getBoundingClientRect().top -
            scrollPosition,
        );
        let insetLeft;
        let insetTop;
        if (zoomLeft < imageWidth / zoomFactor / 2) {
          zoomLeft = 0;
          insetLeft = 0;
        } else if (zoomLeft > -1 + imageWidth - imageWidth / zoomFactor / 2) {
          zoomLeft = -1 + imageWidth - imageWidth / zoomFactor;
          insetLeft = zoomLeft + 1;
          zoomLeft *= zoomFactor * scaleFactor;
        } else {
          zoomLeft -= imageWidth / zoomFactor / 2;
          insetLeft = zoomLeft;
          zoomLeft *= zoomFactor * scaleFactor;
        }
        if (zoomTop < imageHeight / zoomFactor / 2) {
          zoomTop = 0;
          insetTop = 0;
        } else if (zoomTop > -1 + imageHeight - imageHeight / zoomFactor / 2) {
          zoomTop = -1 + imageHeight - imageHeight / zoomFactor;
          insetTop = zoomTop + 1;
          zoomTop *= zoomFactor * scaleFactor;
        } else {
          zoomTop -= imageHeight / zoomFactor / 2;
          insetTop = zoomTop;
          zoomTop *= zoomFactor * scaleFactor;
        }
        zoomLeft *= -1;
        zoomTop *= -1;
        zoomedImage.style.left = `${zoomLeft}px`;
        zoomedImage.style.top = `${zoomTop}px`;
        document.getElementById("zoom-overlay").style.left = `${insetLeft}px`;
        document.getElementById("zoom-overlay").style.top = `${insetTop}px`;
      }
    };

    const resetPos = () => {
      imageHeight = mainImageContainer.offsetHeight;
      scrollPosition = window.scrollY;
    };

    const resetSize = () => {
      imageHeight = mainImageContainer.offsetHeight;
      scrollPosition = window.scrollY;
    };

    document
      .getElementById("product-main-image-container")
      .addEventListener("mouseenter", zoomEnter);
    document
      .getElementById("product-main-image-container")
      .addEventListener("mouseleave", zoomLeave);
    document
      .getElementById("product-main-image-container")
      .addEventListener("mousemove", zoomMove);

    window.addEventListener("resize", resetSize);
    window.addEventListener("scroll", resetPos);
  }

  /**
   * Handles upsells
   * Dresses in this fabric, complete the look
   */

  if (
    window.location.href.includes("/products/") &&
    document.querySelector(".cross-sell-upsell-box")
  ) {
    const tags = JSON.parse(
      document.querySelector(".cross-sell-upsell-box").dataset.tags,
    );
    let { title } = document.querySelector(".cross-sell-upsell-box").dataset;
    let { type } = document.querySelector(".cross-sell-upsell-box").dataset;
    const searchTags = [];

    tags.forEach((tag) => {
      if (tag.includes("Theme") || tag.includes("Upsell")) {
        searchTags.push(tag);
      }
    });

    const items = [];

    window?.cart?.items.forEach((item) => {
      items.push(item.product_id);
    });
    if (type === "Swatch") {
      getSwatchUpsells(searchTags, title);
    } else if (searchTags.length > 0) {
      getUpsells(searchTags, items);
    }
  }

  document.querySelectorAll(".close-bis").forEach((close) => {
    close.addEventListener("click", closeBackInStockModal);
    // close.addEventListener('keydown', enterEvent);
  });

  // Start Personalizer
  document.querySelectorAll(".personalizer").forEach((input) => {
    input.addEventListener("change", cleanInput);
    input.addEventListener("input", cleanInput);
    input.addEventListener("keypress", cleanKeys);
  });
  // End Personalizer

  if (document.getElementById("bis-submit")) {
    document.getElementById("bis-submit").addEventListener("click", submitBis);
  }

  if (document.getElementById("bis-email")) {
    document.getElementById("bis-email").addEventListener("change", verifyIt);
    document.getElementById("bis-email").addEventListener("input", verifyIt);
  }

  document.querySelectorAll(".product-image-container").forEach((container) => {
    container.addEventListener("mouseenter", showProductGalleryButtons);
    container.addEventListener("mouseleave", hideProductGalleryButtons);
  });

  if (document.getElementById("sort-product-reviews")) {
    document
      .getElementById("sort-product-reviews")
      .addEventListener("change", sortReviews);
    document
      .getElementById("sort-product-reviews")
      .addEventListener("input", sortReviews);
  }

  const reviewsLink = document.querySelector(".reviews-link");
  if (reviewsLink) {
    reviewsLink.addEventListener("click", scrollToReviews);
  }

  document
    .querySelectorAll(".size-dropdown, .length-dropdown")
    .forEach((dropdown) => {
      const trigger = dropdown.querySelector(".dropdown-button");
      const list = dropdown.querySelector(".dropdown-list");
      const close = dropdown.querySelector(".dropdown-close");
      const overlay = dropdown.querySelector(".dropdown-overlay");
      const items = dropdown.querySelectorAll(".dropdown-list .dropdown-item");

      trigger &&
        overlay &&
        list &&
        trigger.addEventListener("click", function () {
          list.style.display =
            list.style.display === "block" ? "none" : "block";
          overlay.style.display =
            overlay.style.display === "block" ? "none" : "block";
          this.parentNode.focus();
        });
      trigger &&
        overlay &&
        list &&
        dropdown.addEventListener("blur", () => {
          list.style.display = "none";
          overlay.style.display = "none";
        });
      items &&
        overlay &&
        list &&
        trigger &&
        items.forEach((option) => {
          option.addEventListener("click", () => {
            dropdown.setAttribute("value", option.dataset.value);
            dropdown.classList.remove("has-error");
            dropdown.classList.add("selected");
            items.forEach((option) => {
              option.classList.remove("checked");
            });
            option.classList.add("checked");
            list.style.display = "none";
            overlay.style.display = "none";
            trigger.style.fontWeight = 700;
            trigger.ariaExpanded = !trigger.ariaExpanded;
            trigger.querySelector("span").innerText = option.dataset.value;
            if (dropdown.classList.contains("size-dropdown")) {
              const parentContainer = dropdown.closest(".size-radios");
              parentContainer
                ?.querySelectorAll('[role="radiogroup"] input')
                .forEach((input) => {
                  if (input.value === option.dataset.value) {
                    parentContainer
                      .querySelector(
                        `[role="radiogroup"] label[for="${input.id}"]`,
                      )
                      .click();
                  }
                });
            } else if (dropdown.classList.contains("length-dropdown")) {
              const parentContainer = dropdown.closest(".length-radios");
              parentContainer
                ?.querySelectorAll('[role="radiogroup"] input')
                .forEach((input) => {
                  if (input.value === option.dataset.value) {
                    parentContainer
                      .querySelector(
                        `[role="radiogroup"] label[for="${input.id}"]`,
                      )
                      .click();
                  }
                });
            }
          });
          option.addEventListener("keydown", (e) => {
            const dropdownButton = document.querySelector(".dropdown-button");
            if (
              (e.key === "Enter" || e.key === " ") &&
              dropdownButton.ariaExpanded === "true"
            ) {
              e.target.click();
              window.removeEventListener("keydown", focusTrap);
              dropdownButton.focus();
            }
          });
          if (
            sessionStorage &&
            [
              sessionStorage.getItem("pdp-standard-size-preselect"),
              sessionStorage.getItem("pdp-standard-wide-size-preselect"),
              sessionStorage.getItem("pdp-standard-full-size-preselect"),
              sessionStorage.getItem("pdp-number-size-preselect"),
              sessionStorage.getItem("pdp-alphabet-size-preselect"),
            ].find((size) => size === option.dataset.value)
          ) {
            option.click();
          }
        });
      close &&
        overlay &&
        list &&
        close.addEventListener("click", () => {
          list.style.display = "none";
          overlay.style.display = "none";
          trigger.ariaExpanded = !trigger.ariaExpanded;
        });
      trigger &&
        overlay &&
        list &&
        document.addEventListener("click", (e) => {
          const isOpen = list.style.display === "block";
          const clickedOutside =
            !trigger.contains(e.target) &&
            !overlay.contains(e.target) &&
            !list.contains(e.target);

          if (isOpen && clickedOutside) {
            list.style.display = "none";
          }
        });
    });
  document
    .querySelectorAll(".product-wrapper .tab-heading")
    .forEach((heading) => {
      heading.addEventListener("click", toggleTab);
      heading.addEventListener("keydown", enterEvent);
    });

  document.querySelectorAll(".carousel-button").forEach((button) => {
    button.addEventListener("click", moveCarousel);
    button.addEventListener("keydown", enterEvent);
  });

  // PDP - Size Dropdown Keyboard Listeners
  const sizeDropdownButton = document.querySelector(
    ".size-dropdown .dropdown-button",
  );

  const toggleSizeButton = (e) => {
    const dropdownList = document.querySelector(".dropdown-size-list");
    const isOpen = e.target.ariaExpanded === "true";

    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      e.target.click();
      e.target.ariaExpanded = !isOpen;
      if (!isOpen) {
        window.toTrap = dropdownList;
        window.addEventListener("keydown", focusTrap);
        setTimeout(() => {
          dropdownList.focus();
        }, 100);
      } else {
        window.removeEventListener("keydown", focusTrap);
        setTimeout(() => sizeDropdownButton.focus(), 100);
      }
    } else if (e.key === "Escape" && isOpen) {
      e.preventDefault();
      e.target.click();
      e.target.ariaExpanded = "false";
      window.removeEventListener("keydown", focusTrap);
      setTimeout(() => sizeDropdownButton.focus(), 100);
    }
  };

  if (sizeDropdownButton) {
    sizeDropdownButton.addEventListener("keydown", toggleSizeButton);
    document
      .querySelector(".dropdown-list")
      .addEventListener("keydown", (e) => {
        if (e.key === "Escape" && sizeDropdownButton.ariaExpanded === "true") {
          e.preventDefault();
          sizeDropdownButton.click();
          sizeDropdownButton.ariaExpanded = "false";
          window.removeEventListener("keydown", focusTrap);
          setTimeout(() => sizeDropdownButton.focus(), 10);
        }
      });
  }

  document.querySelectorAll(".product-image-button").forEach((button) => {
    button.addEventListener("click", moveProductCarousel);
    button.addEventListener("keydown", enterEvent);
  });

  // hide error label on radio clicks
  document.querySelectorAll(".size-radio").forEach((radio) => {
    radio.addEventListener("click", () => {
      document.getElementById("size-not-selected")?.remove();

      document.querySelectorAll(".slit-variation-radio").forEach((radio) => {
        if (radio.checked) {
          document.getElementById("size-variant-not-selected")?.remove();
        }
      });
    });
  });

  document.querySelectorAll(".slit-variation-radio").forEach((radio) => {
    radio.addEventListener("click", () => {
      document.getElementById("variant-not-selected")?.remove();
      document.querySelectorAll(".size-radio").forEach((radio) => {
        if (radio.checked) {
          document.getElementById("size-variant-not-selected")?.remove();
        }
      });
    });
  });

  document.querySelectorAll(".atc").forEach((button) => {
    button.addEventListener("click", atcClick);
    button.addEventListener("keydown", enterEvent);
  });

  document.querySelectorAll(".select-dropdown").forEach((select) => {
    select.addEventListener("mousedown", checkDropdown);
  });

  document.querySelectorAll(".dropdown-value").forEach((value) => {
    value.addEventListener("click", changeDropdown);
    value.addEventListener("keydown", enterEvent);
  });

  document.querySelectorAll(".play-button").forEach((button) => {
    button.addEventListener("click", playVideo);
    button.addEventListener("keydown", enterEvent);
  });

  document.querySelectorAll(".anchor-link").forEach((anchor) => {
    anchor.addEventListener("click", scrollToAnchor);
    anchor.addEventListener("keydown", enterEvent);
  });

  document.querySelectorAll(".view-size-chart").forEach((button) => {
    button.addEventListener("click", generateSizeChart);

    // button.addEventListener('keydown', enterEvent);
  });

  const generalModalMessage = document.querySelector(".general-modal-message");
  const generalModalTriggers = document.querySelectorAll(
    ".general-modal-trigger",
  );
  const generalModalOverlay = document.querySelector(".general-modal-overlay");
  const generalModalClose = document.querySelector(".general-modal-close");
  const generalModalCloseImg = document.querySelector(
    ".general-modal-close img",
  );

  generalModalTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      if (
        e.target === generalModalClose ||
        e.target === generalModalCloseImg ||
        e.target.tagName === "A"
      ) {
        return;
      }
      e.preventDefault();
      generalModalMessage.classList.remove("none");
      generalModalMessage.classList.add("active");
      generalModalOverlay.classList.remove("hidden");
    });
  });

  generalModalClose?.addEventListener("click", (e) => {
    closeGeneralModal(e);
  });

  generalModalOverlay?.addEventListener("click", (e) => {
    closeGeneralModal(e);
  });

  function closeGeneralModal(e) {
    e.preventDefault();
    generalModalMessage.classList.add("none");
    generalModalMessage.classList.remove("active");
    generalModalOverlay.classList.add("hidden");
  }

  const generalPreorderModalMessage = document.querySelector(
    ".general-preorder-modal-message",
  );
  const generalPreorderModalTriggers = document.querySelectorAll(
    ".general-preorder-modal-trigger",
  );
  const generalPreorderModalOverlay = document.querySelector(
    ".general-preorder-modal-overlay",
  );
  const generalPreorderModalClose = document.querySelector(
    ".general-preorder-modal-close",
  );
  const generalPreorderModalCloseImg = document.querySelector(
    ".general-preorder-modal-close img",
  );

  generalPreorderModalTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      if (
        e.target === generalPreorderModalClose ||
        e.target === generalPreorderModalCloseImg ||
        e.target.tagName === "A"
      ) {
        return;
      }
      e.preventDefault();
      generalPreorderModalMessage.classList.remove("none");
      generalPreorderModalMessage.classList.add("active");
      generalPreorderModalOverlay.classList.remove("hidden");
    });
  });

  generalPreorderModalClose?.addEventListener("click", (e) => {
    closeGeneralPreorderModal(e);
  });

  generalPreorderModalOverlay?.addEventListener("click", (e) => {
    closeGeneralPreorderModal(e);
  });

  function closeGeneralPreorderModal(e) {
    e.preventDefault();
    generalPreorderModalMessage.classList.add("none");
    generalPreorderModalMessage.classList.remove("active");
    generalPreorderModalOverlay.classList.add("hidden");
  }

  const mtoModalMessage = document.querySelector(".mto-modal-message");
  const mtoModalTriggers = document.querySelectorAll(".mto-modal-trigger");
  const mtoModalOverlay = document.querySelector(".mto-modal-overlay");
  const mtoModalClose = document.querySelector(".mto-modal-close");
  const mtoModalCloseImg = document.querySelector(".mto-modal-close img");

  mtoModalTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      if (
        e.target === mtoModalClose ||
        e.target === mtoModalCloseImg ||
        e.target.tagName === "A"
      ) {
        return;
      }
      e.preventDefault();
      mtoModalMessage.classList.remove("none");
      mtoModalMessage.classList.add("active");
      mtoModalOverlay.classList.remove("hidden");
    });
  });

  mtoModalClose?.addEventListener("click", (e) => {
    closeMtoModal(e);
  });

  mtoModalOverlay?.addEventListener("click", (e) => {
    closeMtoModal(e);
  });

  function closeMtoModal(e) {
    e.preventDefault();
    mtoModalMessage.classList.add("none");
    mtoModalMessage.classList.remove("active");
    mtoModalOverlay.classList.add("hidden");
  }

  const preorderModalMessage = document.querySelector(
    ".preorder-modal-message",
  );
  const preorderModalTriggers = document.querySelectorAll(
    ".preorder-modal-trigger",
  );
  const preorderModalOverlay = document.querySelector(
    ".preorder-modal-overlay",
  );
  const preorderModalClose = document.querySelector(".preorder-modal-close");
  const preorderModalCloseImg = document.querySelector(
    ".preorder-modal-close img",
  );

  preorderModalTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      if (
        e.target === preorderModalClose ||
        e.target === preorderModalCloseImg ||
        e.target.tagName === "A"
      ) {
        return;
      }
      e.preventDefault();
      preorderModalMessage.classList.remove("none");
      preorderModalMessage.classList.add("active");
      preorderModalOverlay.classList.remove("hidden");
    });
  });

  function closePreorderModal(e) {
    e.preventDefault();
    preorderModalMessage.classList.add("none");
    preorderModalMessage.classList.remove("active");
    preorderModalOverlay.classList.add("hidden");
  }

  preorderModalClose?.addEventListener("click", (e) => {
    closePreorderModal(e);
  });

  preorderModalOverlay?.addEventListener("click", (e) => {
    closePreorderModal(e);
  });

  const fabricModalTrigger = document.getElementById("fabric-modal-trigger");
  const fabricModal = document.querySelector("fabric-modal");

  if (fabricModalTrigger) {
    fabricModalTrigger.addEventListener("click", (e) => {
      e.repeat && e.preventDefault();
      fabricModal.modal.classList.remove("hidden");
      fabricModal.overlay.classList.remove("hidden");
      e.stopPropagation();
    });
  }

  const updatePDPmessagingIfNoSizesExist = () => {
    // TODO: We can refactor this work after messaging and product.js is decoupled further
    // Early exit if variant sizes exist
    const variantSizesExist = document.querySelector("variant-sizes");
    if (variantSizesExist) return;

    // Grab new DOM elements after re-render
    const variantSelectOptions = document.querySelectorAll(
      ".variant-select option",
    );
    const bisMessage = document.querySelector("#bis-message");
    const madeToOrderNote = document.getElementById("madetoorder-text");
    const productionTimelineMessage =
      document.getElementById("shipping-message");
    const preorderText = document.getElementById("preorder-text");
    const preorderArriveNote = document.querySelector(".preorder-arrive-note");
    const selectedOption = [...variantSelectOptions].find(
      (option) => option.selected,
    );

    if (!selectedOption) return;

    updateMessaging(
      selectedOption,
      bisMessage,
      madeToOrderNote,
      productionTimelineMessage,
      preorderText,
      preorderArriveNote,
    );
  };

  const updateMessaging = (
    selectedOption,
    bisMessage,
    madeToOrderNote,
    productionTimelineMessage,
    preorderText,
    preorderArriveNote,
  ) => {
    if (selectedOption.dataset.madetoorder) {
      showElements(madeToOrderNote, productionTimelineMessage);
    } else if (selectedOption.dataset.preorder) {
      if (preorderText && preorderArriveNote) {
        preorderArriveNote.textContent = `${selectedOption.dataset.preorder}`;
        showElements(preorderText);
      }
    } else if (selectedOption.dataset.backinstock) {
      showElements(bisMessage);
    }
  };

  updatePDPmessagingIfNoSizesExist();

  initialStampedLoad = false;
  stampedInit();

  // Generate back in stock modal upon PDP initialize or re-render
  const selectedVariant = getSelectedVariantElement();
  if (selectedVariant) generateBackInStockModalData(selectedVariant);
}

initProduct();
